'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = reducer;
exports.set = set;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SET = 'pageFocusedField/SET';

var initialState = {
  hotelInfoCheckin: false,
  hotelInfoCheckout: false
  // TODO: add another field name with default false boolean value as below,
  // fieldNameYouWantToFocus: false
  // Naming rule: pageNameFieldName (camel case)
};

function reducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  switch (action.type) {
    case SET:
      return (0, _extends3.default)({}, initialState, action.focusedField);
    default:
      return state;
  }
}

function set() {
  var focusedField = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  return {
    type: SET,
    focusedField: focusedField
  };
}


//////////////////
// WEBPACK FOOTER
// ./src/modules/pageFocusedField.js
// module id = 282
// module chunks = 0